module.exports = __webpack_public_path__ + "static/img/8-广田集团.103c93fa.png";